import { AxiosPromise } from "axios";
import { ButtonPrimary, ButtonWarning } from "components/Atoms/Button";
import React from "react";

interface Props {
  timeZone: string;
  setTimeZone: (timeZone: string) => AxiosPromise<server.dto.ApiResponse | server.dto.ApiResponseWrapper<any>>;
}

export const SpecifyTime = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const setTimeZone = async (timeZone: string | null) => {
    setIsLoading(true);
    await props.setTimeZone(timeZone);
    setIsLoading(false);
  }

  return <div>
    {!props.timeZone && <ButtonWarning loading={isLoading} label={RESX.Feed.UseFeatureUnsafe} onClick={() => {
      setTimeZone(site.userPreference.regional.ianaTimeZoneId);
    }} />}
    {props.timeZone && <ButtonPrimary loading={isLoading} label={RESX.Feed.BackToSafeMode} onClick={() => setTimeZone(null)} />}
  </div>
}